import React from "react";
import styles from '../styling/BudgetCard.module.css'
import { CardDiv, Name, Amount, Label, Input } from "../styling/BudgetStyles";

function BudgetCard({name, amount, dispatch}) {

    const handleChange = ({target}) => {
       let value = Number(target.value)

        if (value < 0 || typeof value !== 'number' || !value) {
            return
        }

        dispatch({
        type: 'budgets/changeBudget',
        payload: {
            category: name,
            amount: value,
        },
    })
    }

    return (
        <CardDiv>
            <Name>{name}</Name>
            <Amount>Balance</Amount>
            <Amount>${amount}</Amount> {/*Conditional formatting */}
            <Label htmlFor={name}>Type to change budget</Label><br/>
            <Input className={styles.input} autoComplete="off" type="number" required id={name} placeholder="$1000" onBlur={handleChange} />
        </CardDiv>
    )
}

export default BudgetCard;